import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import placeholderImage from "../../components/assets/image/placeholder.png";
import localStorageServices from "../../services/LocalStorage";
import { LocalStorageKeys } from "../../constant/LocalStorageKeys";
import { ApiURLs, imageBaseUrls } from "../../constant/ApiUrls";
import { useDispatch } from 'react-redux';
import { addBlogRequest, getBlog } from './redux/blogDispatcher';
import { NavigationRoutes } from '../../constant/Routes';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from "react-select";
import { useMemo } from 'react';

const AddBlog = () => {
  const { id } = useParams();
  let parentId = 0;
  if (id) {
    const m = id.replace(":", "");
    if (m) {
      parentId = m;
    }
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const options = useMemo(() => [
    { label: "Motor", value: 1 },
    { label: "Farming", value: 2 },
    { label: "Property", value: 3 }
  ], []);
  const [selectedOptions, setSelectedOptions] = useState(null);


  const [title, setTitle] = useState('');
  const [readingTime, setReadingTime] = useState('');
  const [image, setImage] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [editorData, setEditorData] = useState('<br></br><br></br><br></br>');
  const editorRef = useRef(null);
  // const [isVehicle, setIsVehicle] = useState(false);
  const [isShowBanner, setIsShowBanner] = useState(false);
  const [isElectricCar, setIsElectricCar] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);

  const fetchedRef = React.useRef(false);
  const [data, setDaata] = useState(null);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (parentId !== 0 && !fetchedRef.current) {
      fetchedRef.current = true;
      setInitialLoading(true);

      const fetchBlogs = async () => {
        try {
          const result = await dispatch(getBlog(parentId));
          console.log("Fetched blogs:", result);

          if (Array.isArray(result) && result.length > 0) {
            var v = result[0];
            setDaata(result[0]); // Take the first object
            console.log("Blog Data:", v);

            // Optionally set state from this data
            setTitle(v?.title || '');
            setReadingTime(v?.read_time || '');
            setEditorData(v?.description || '');
            if (v.type) {
              var selected = options.find((e) => e.value === v.type);

              console.log("selectedselected::", selected, v.type)
              if (selected) {
                setSelectedOptions(selected);
              }

            }
            // setIsVehicle(v?.is_vehicle === 1);
            setIsShowBanner(v?.is_show_banner === 1);
            setIsElectricCar(v?.is_electric_car === 1);

            if (v?.image_url) setImage(imageBaseUrls(v.image_url));
          }
        } catch (error) {
          console.error("Error fetching blogs:", error);
        } finally {
          setInitialLoading(false); // stop loader only after API completes
        }
      };

      fetchBlogs();
    }
  }, [parentId, dispatch, options]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setImage(imageUrl);
        setUploadImage(file);
      } else {
        alert("Please select a valid image file (JPEG, PNG, JPG)");
      }
    }
  };

  const handleSubmit = async () => {



    if (title.trim() === "") return alert("Blog title is required");
    if (readingTime.trim() === "") return alert("Blog reading time is required");
    console.log("chdjshcjd", selectedOptions);

    if (!selectedOptions) return alert("Blog type is required");

    if (editorData.trim() === "<br></br><br></br><br></br>") return alert("Blog description is required");
    if (!image) return alert("Blog image is required");

    setIsLoading(true);

    const d = {
      title,
      description: editorData,
      read_time: readingTime,
      // is_vehicle: isVehicle ? 1 : 0,
      is_show_banner: isShowBanner ? 1 : 0,
      is_electric_car: isElectricCar ? 1 : 0,

      type: selectedOptions.value,

      ...(uploadImage ? { image: uploadImage } : { image_url: data.image_url.replace(imageBaseUrls(null), '') }),
      ...(data !== null && { id: data.id }),
    };



    console.log("DATDADATDAT:::::", d, imageBaseUrls(null));
    await dispatch(addBlogRequest(d));
    if (data !== null) {
      toast.success("Blog update successfully");

    }
    navigate(NavigationRoutes.ADMIN_DASHBOARD + NavigationRoutes.BLOG);


    setTitle('');
    editorRef.current.setData('<br></br><br></br><br></br>');

    setEditorData('');
    setReadingTime('');
    setImage(null);
    setUploadImage(null);
    setIsLoading(false);
    setIsShowBanner(false);
    setIsElectricCar(false);
    // setIsVehicle(false);
    setSelectedOptions(null);

  };

  if (initialLoading) {
    return (
      <Box sx={styles.loaderContainer}>
        <CircularProgress color="primary" size={60} />
      </Box>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <label style={styles.label}>Blog Image</label>
      <div className="mb-3 input-login-box">
        <div className="form-row d-flex justify-content-center mt-2">
          <input
            type="file"
            accept="image/*"
            id="categoryImageUpload"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
          <img
            style={{
              height: "160px",
              width: "200px",
              borderRadius: "10px",
              objectFit: "cover"
            }}
            onClick={() =>
              document.getElementById("categoryImageUpload").click()
            }
            src={image || placeholderImage}
            alt="Preview"
          />
        </div>
      </div>
      <div><br /></div>

      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ flex: 1 }}>
          <label style={styles.label}>Blog Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter blog title"
            style={{ ...styles.input, width: '100%' }}
            required
          />
        </div>

        <div style={{ flex: 1 }}>
          <label style={styles.label}>Blog Reading Time (in minutes)</label>
          <input
            type="number"
            value={readingTime}
            onChange={(e) => setReadingTime(e.target.value)}
            placeholder="Enter blog reading time"
            style={{ ...styles.input, width: '100%' }}
            required
            min="0"
            step="1"
          />
        </div>
      </div>


      <br></br>

      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ flex: 1 }}>
          <label style={styles.label}>Blog Type</label>
          <Select
            options={options}
            value={selectedOptions}
            onChange={setSelectedOptions}
            placeholder="Select blog type..."
          />
        </div>

        <div style={{ flex: 1 }}>

        </div>
      </div>

      <div><br /></div>

      <label style={styles.label}>Blog Description</label>
      <CKEditor
        editor={ClassicEditor}
        data={editorData}
        config={{
          simpleUpload: {
            uploadUrl: ApiURLs.UPLOAD_IMAGE,
            headers: {
              Authorization: `Bearer ${localStorageServices.getItem(LocalStorageKeys.userToken)}`
            },
          },
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setEditorData(data);
        }}
        onReady={(editor) => {
          editorRef.current = editor; // Save the instance to ref
        }}

      />

      <div><br /></div>

      <div className="d-flex gap-4">
        {/* <div className="mb-3 form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="recommendedCheck"
      checked={isVehicle}
      onChange={() => setIsVehicle(!isVehicle)}
    />
    <label className="form-check-label" htmlFor="recommendedCheck">
      Is Vehicle?
    </label>
  </div> */}

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="bannerCheck"
            checked={isShowBanner}
            onChange={() => setIsShowBanner(!isShowBanner)}
          />
          <label className="form-check-label" htmlFor="bannerCheck">
            Show Banner?
          </label>
        </div>




        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="bannerCheck"
            checked={isElectricCar}
            onChange={() => setIsElectricCar(!isElectricCar)}
          />
          <label className="form-check-label" htmlFor="bannerCheck">
            Is Electric Car?
          </label>
        </div>

      </div>


      <div><br /></div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <button
          type="submit"
          style={{ ...styles.button, width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} style={{ color: 'white' }} />
          ) : (
            parentId !== 0 ? "Update Blog" : "Add Blog"
          )}
        </button>
      </div>

      <div><br /><br /></div>
    </div>
  );
};

const styles = {
  label: {
    fontWeight: 'bold',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
  },
  button: {
    padding: '12px',
    backgroundColor: '#007bff',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  loaderContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default AddBlog;
